/**
 * RFQ (Request For Quotation) modal controller.
 *
 * - Buttons with [data-rfq-open] trigger the modal.
 *   They carry data-rfq-product-title and data-rfq-product-url.
 * - Close via [data-rfq-close] (overlay + X button) or Escape key.
 * - Sets the hidden product field so the email shows which product was requested.
 */
(function () {
  'use strict';

  var modal, productNameEl, productField, firstInput;

  function getModal() {
    if (!modal) {
      modal = document.getElementById('RfqModal');
      if (modal) {
        productNameEl = modal.querySelector('[data-rfq-product-name]');
        productField = modal.querySelector('[data-rfq-product-field]');
        firstInput = modal.querySelector('input[type="text"]');
      }
    }
    return modal;
  }

  function openModal(title, url) {
    var m = getModal();
    if (!m) return;

    if (productNameEl) productNameEl.textContent = title || '';
    if (productField) productField.value = 'Richiesta preventivo per: ' + (title || '') + ' — ' + (url || '');

    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Focus first input after animation
    setTimeout(function () {
      if (firstInput) firstInput.focus();
    }, 100);
  }

  function closeModal() {
    var m = getModal();
    if (!m) return;
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function onOpenClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    var btn = evt.currentTarget;
    var title = btn.getAttribute('data-rfq-product-title') || '';
    var url = btn.getAttribute('data-rfq-product-url') || '';
    openModal(title, url);
  }

  function bindOpeners() {
    document.querySelectorAll('[data-rfq-open]').forEach(function (btn) {
      if (btn.__rfqBound) return;
      btn.__rfqBound = true;
      btn.addEventListener('click', onOpenClick);
    });
  }

  function init() {
    var m = getModal();
    if (!m) return;

    // Close buttons
    m.querySelectorAll('[data-rfq-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    // Escape key
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && m.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    bindOpeners();

    // Re-bind after AJAX collection reload (catalog filters, pagination, etc.)
    document.addEventListener('collection:reloaded', function () {
      setTimeout(bindOpeners, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
